export default "__VITE_ASSET__Dfl7orWU__"